module.exports = new __parcel__URL__("pve_button_text.f109f0c0.png").toString();